import ActiveNumbersTable from './ActiveNumbersTable';

export default ActiveNumbersTable;
